const FinancingInfo = () => {

  return (
    <div className="financing">
      <img src='/EU.png' className='financing-img' alt='EU Partial Financing'></img>
      <img src='/Pirkan_Helmi.png' className='financing-img' alt='Pirkan Helmi'></img>
    </div>
  );
}
  
export default FinancingInfo;